import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

export default class extends Controller {
  static values = {
    showSearch:        { type: Boolean, default: true },
    placeholder:       { type: String,  default: ' - ' },
    searchPlaceholder: { type: String,  default: 'Поиск...' },
    searchText:        { type: String,  default: 'Ничего не найдено' },
    allowDeselect:     { type: Boolean, default: false },
  }

  connect() {
    this._slim = new SlimSelect({
      select: this.element,
      settings: {
        showSearch:        this.showSearchValue,
        placeholderText:   this.placeholderValue,
        searchPlaceholder: this.searchPlaceholderValue,
        searchText:        this.searchTextValue,
        allowDeselect:     this.allowDeselectValue,
        closeOnSelect:     true,
      }
    })
  }

  disconnect() {
    this._slim?.destroy()
  }
}
